import { Reader, Writer } from 'protobufjs/minimal';

export interface IInt32Value {
    /** The int32 value. */
    value?: number;
}
type Int32ValueWithTag = IInt32Value & {};
type Int32ValueKey = keyof IInt32Value;

function createBaseInt32Value() {
    return { value: 0 };
}

function createBaseStringValue() {
    return { value: '' };
}

export class Int32Value {
    public static keyList: Int32ValueKey[] = ['value'];
    public static createAttributeInstance(options: IInt32Value): Int32Value {
        const newInstance = new Int32Value(options);
        return newInstance;
    }
    public static deserializeBuffer<T extends keyof IInt32Value>(options: Int32ValueWithTag) {
        const newOptions: IInt32Value = {};
        if (!options || typeof options !== 'object') {
            return options;
        }
        Int32Value.keyList.forEach((key: T) => {
            if (options[key] !== undefined) {
                newOptions[key] = options[key];
            }
        });
        return newOptions;
    }
    public static preSerialize<T extends keyof IInt32Value>(data: IInt32Value): Int32ValueWithTag {
        const newInstance: Int32ValueWithTag = {};
        Int32Value.keyList.forEach((key: T) => {
            if (data[key] !== undefined) {
                newInstance[key] = data[key];
            }
        });
        return newInstance;
    }
    public static decode(input: Reader | Uint8Array, length?: number) {
        const reader = input instanceof Reader ? input : new Reader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message: any = createBaseInt32Value();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    }
    public static encode(message: any, writer: Writer = Writer.create()): Writer {
        if (message.value !== undefined) {
            writer.uint32(8).int32(message.value);
        }
        return writer;
    }
    /** The int32 value. */
    value?: number;
    constructor(options?: IInt32Value) {
        if (options?.value !== undefined) {
            this.value = options.value;
        }
    }
    public clone(): Int32Value {
        const options: IInt32Value = {};
        options.value = this.value;
        return new Int32Value(options);
    }
}

/**
 * Wrapper message for `string`.
 *
 * The JSON representation for `StringValue` is JSON string.
 */
export interface IStringValue {
    /** The string value. */
    value?: string;
}
type StringValueWithTag = IStringValue & {};
type StringValueKey = keyof IStringValue;


export class StringValue {
    public static keyList: StringValueKey[] = ['value'];
    public static createAttributeInstance(options: IStringValue): StringValue {
        const newInstance = new StringValue(options);
        return newInstance;
    }
    public static deserializeBuffer<T extends keyof IStringValue>(options: StringValueWithTag) {
        const newOptions: IStringValue = {};
        if (!options || typeof options !== 'object') {
            return options;
        }
        StringValue.keyList.forEach((key: T) => {
            if (options[key] !== undefined) {
                newOptions[key] = options[key];
            }
        });
        return newOptions;
    }
    public static preSerialize<T extends keyof IStringValue>(data: IStringValue): StringValueWithTag {
        const newInstance: StringValueWithTag = {};
        StringValue.keyList.forEach((key: T) => {
            if (data[key] !== undefined) {
                newInstance[key] = data[key];
            }
        });
        return newInstance;
    }
    public static decode(input: Reader | Uint8Array, length?: number) {
        const reader = input instanceof Reader ? input : new Reader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message: any = createBaseStringValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    }
    public static encode(message: any, writer: Writer = Writer.create()): Writer {
        if (message.value !== undefined) {
            writer.uint32(10).string(message.value);
        }
        return writer;
    }
    /** The string value. */
    value?: string;
    constructor(options?: IStringValue) {
        if (options?.value !== undefined) {
            this.value = options.value;
        }
    }
    public clone(): StringValue {
        const options: IStringValue = {};
        options.value = this.value;
        return new StringValue(options);
    }
}
